import React from "react";
import { Box } from "arkh";

export function WorkspaceSignalStoreItemContainer(props: {
  storeName: React.ReactNode;
  seen: React.ReactNode;
}) {
  return (
    <Box style={{ flexDirection: "row", flex: 1, alignItems: "center" }}>
      <Box style={{ width: "70%" }}>{props.storeName}</Box>
      <Box style={{ width: "30%", flexDirection: "row" }}>{props.seen}</Box>
    </Box>
  );
}
